import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login from './pages/Login';
import AdminDashboard from './pages/admin/Dashboard';
import TeacherDashboard from './pages/teacher/Dashboard';
import StudentDashboard from './pages/student/Dashboard';

const PrivateRoute = ({ children, role }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role) return <Navigate to="/login" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin/*" element={
            <PrivateRoute role="admin">
              <AdminDashboard />
            </PrivateRoute>
          } />
          <Route path="/teacher/*" element={
            <PrivateRoute role="teacher">
              <TeacherDashboard />
            </PrivateRoute>
          } />
          <Route path="/student/*" element={
            <PrivateRoute role="student">
              <StudentDashboard />
            </PrivateRoute>
          } />
          <Route path="/" element={<Navigate to={
  localStorage.getItem('user') 
    ? (JSON.parse(localStorage.getItem('user')).role === 'admin' ? '/admin' 
      : JSON.parse(localStorage.getItem('user')).role === 'teacher' ? '/teacher' 
      : '/student')
    : '/login'
} />} />
          <Route path="*" element={<Navigate to={
  localStorage.getItem('user') 
    ? (JSON.parse(localStorage.getItem('user')).role === 'admin' ? '/admin' 
      : JSON.parse(localStorage.getItem('user')).role === 'teacher' ? '/teacher' 
      : '/student')
    : '/login'
} />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;